import * as React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { FeatureFlagsListPage } from '../../features/admin/feature-flags/components/feature-flags-list-page';
import { SYSTEM_ROLE_CODE } from '../../features/permissions/lib/role-codes';
import { PageTitleContext } from '../__root';

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/feature-flags')({
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user || !user.roles.includes(SYSTEM_ROLE_CODE)) {
      throw redirect({ to: '/media-units' });
    }
  },
  component: FeatureFlagsRoute,
});

function FeatureFlagsRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('admin');

  React.useEffect(() => {
    setPageTitle(t('featureFlags.pageTitle'));
  }, [setPageTitle, t]);

  return <FeatureFlagsListPage />;
}
